import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0F1419] text-white">
      {/* Footer CTA Section */}
      <div className="bg-[#1A2B4A] py-20">
        <div className="max-w-[700px] mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold text-white mb-5">
            Ready to Transform Your Home?
          </h2>
          <p className="text-xl text-white/70 mb-12">
            Get a free estimate today
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-5">
            <a
              href="tel:+12695551234"
              className="w-full sm:w-[180px] bg-white text-[#1A2B4A] px-8 py-4 rounded-xl font-semibold text-[15px] hover:bg-gray-100 transition-colors flex items-center justify-center whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              Call Now
            </a>
            <Link
              to="/contact"
              className="w-full sm:w-[180px] bg-transparent border-2 border-white text-white px-8 py-4 rounded-xl font-semibold text-[15px] hover:bg-white/10 transition-colors flex items-center justify-center whitespace-nowrap"
            >
              Request Estimate
            </Link>
          </div>
          <div className="mt-12">
            <a
              href="tel:+12695551234"
              className="text-2xl font-semibold text-white hover:text-[#3B82F6] transition-colors"
            >
              (269) 555-1234
            </a>
            <p className="text-[16px] text-white/60 mt-3">Hablamos Español</p>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="py-16">
        <div className="max-w-[1200px] mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
            {/* Brand Column */}
            <div>
              <img
                src="https://public.readdy.ai/ai/img_res/aa1c1a86-9872-4cff-b8d1-11c484be4ea5.png"
                alt="Joel Painting"
                className="h-12 w-auto mb-4 brightness-0 invert"
              />
              <p className="text-[15px] text-gray-400 leading-relaxed">
                Professional painting services in Southwest Michigan
              </p>
            </div>

            {/* Services Column */}
            <div>
              <h3 className="text-[16px] font-bold text-white uppercase tracking-wider mb-4">
                Services
              </h3>
              <ul className="space-y-3">
                <li>
                  <Link
                    to="/services"
                    className="text-[15px] text-gray-400 hover:text-[#3B82F6] transition-colors"
                  >
                    Interior Painting
                  </Link>
                </li>
                <li>
                  <Link
                    to="/services"
                    className="text-[15px] text-gray-400 hover:text-[#3B82F6] transition-colors"
                  >
                    Exterior Painting
                  </Link>
                </li>
                <li>
                  <Link
                    to="/services"
                    className="text-[15px] text-gray-400 hover:text-[#3B82F6] transition-colors"
                  >
                    Cabinet Refinishing
                  </Link>
                </li>
                <li>
                  <Link
                    to="/services"
                    className="text-[15px] text-gray-400 hover:text-[#3B82F6] transition-colors"
                  >
                    Fence Staining
                  </Link>
                </li>
              </ul>
            </div>

            {/* Service Areas Column */}
            <div>
              <h3 className="text-[16px] font-bold text-white uppercase tracking-wider mb-4">
                Areas
              </h3>
              <ul className="space-y-3">
                <li className="text-[15px] text-gray-400">Kalamazoo</li>
                <li className="text-[15px] text-gray-400">Portage</li>
                <li className="text-[15px] text-gray-400">Plainwell</li>
                <li className="text-[15px] text-gray-400">Three Rivers</li>
                <li className="text-[15px] text-gray-400">Otsego</li>
              </ul>
            </div>

            {/* Contact Column */}
            <div>
              <h3 className="text-[16px] font-bold text-white uppercase tracking-wider mb-4">
                Get In Touch
              </h3>
              <a
                href="tel:+12695551234"
                className="text-xl font-semibold text-white hover:text-[#3B82F6] transition-colors block mb-3"
              >
                (269) 555-1234
              </a>
              <div className="inline-block bg-[#10B981]/20 text-[#10B981] px-3 py-1 rounded-full text-[13px] font-medium">
                Hablamos Español
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between">
            <p className="text-[14px] text-gray-500">
              © {currentYear} Joel Painting. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;